import to from "await-to-js";
import { t } from "i18next";
import { useContext, useEffect } from "react";

import { ColorText } from "../../../../../../components/ColorText/ColorText";
import { Table } from "../../../../../../components/Table/Table";
import { ModalsContext } from "../../../../../../context/modals.context";
import { ExciseWarehouseContext } from "../../../../../../modules/obligee/exciseWarehouse/exciseWarehouse.context";
import { exciseWarehouseService } from "../../../../../../modules/obligee/exciseWarehouse/exciseWarehouse.service";
import { formatDateDDMMYY } from "../../../../../../utils/dateFormatter";
import style from "./MinistryRequestHistoryTable.module.scss";

export const MinistryRequestHistoryTable = () => {
  const { exciseWarehouse, setExciseWarehouse } = useContext(
    ExciseWarehouseContext
  );
  const { setError } = useContext(ModalsContext);

  let queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");

  const colDef = [
    { title: t("TABLES.BROJ_ZAHTEVA"), dataIndex: "brojZahteva" },
    {
      title: t("TABLES.DATUM"),
      dataIndex: "datumZahteva",
      render: (datum: string) => formatDateDDMMYY(datum),
    },
    {
      title: t("TABLES.STATUS"),
      dataIndex: "statusZahteva",
      render: (status: any) => ColorText(status),
    },
  ];

  const createIstorijaZahtevaZaSkladiste = async () => {
    const [err, res] = await to(
      exciseWarehouseService.createIstorijaZahtevaZaSkladiste({
        skladisteId: Number(id),
      })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    setExciseWarehouse({
      istorijaZahtevaZaSkladiste: res.data.zahteviZaSkladiste,
    });
  };

  useEffect(() => {
    createIstorijaZahtevaZaSkladiste();
  }, []);

  return (
    <div className={style.mainContainer}>
      <Table
        columns={colDef}
        scrollConfig={["#ministryRequestHistory"]}
        dataSource={exciseWarehouse.istorijaZahtevaZaSkladiste}
        name="mfin-skladista-istorija-zahteva-tabela"
      />
    </div>
  );
};
